import InputAdornment from '@mui/material/InputAdornment';
import TextField, { TextFieldProps } from '@mui/material/TextField';

export default TextField;
export type { TextFieldProps };
export { TextField, InputAdornment };
